import React, { useState } from 'react';
import Calendar from 'components/Calendar';
import APModal from 'components/Modal/APModal';
import { useCalendar } from 'hooks/useCalendar';
import TimezoneDifferenceModal from './components/timezone/TimezoneDifferenceModal';
import TimezoneSetModal from './components/timezone/TimezoneSetModal';

const CalendarIndex = () => {
  const {
    projects,
    events,
    timeZone,
    integration,
    loginCalendarsById,
    isLoaded,
    displayDateTip,
    setDisplayDateTip,
    handleDateChange,
    refetchEvents,
  } = useCalendar();

  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState('');

  /* eslint-disable-next-line no-unused-vars */
  const setErrorModal = (message) => {
    setErrorModalMessage(message);
    setErrorModalOpen(true);
  };

  const errorModalCloseHandler = () => {
    setErrorModalOpen(false);
    setErrorModalMessage(null);
  };

  if (!isLoaded) {
    return null;
  }

  return (
    <div
      className="calendar-page"
    >
      <Calendar
        projects={projects}
        events={events}
        timeZone={timeZone}
        onDateChange={handleDateChange}
        refetchEvents={refetchEvents}
        integration={integration}
        loginCalendarsById={loginCalendarsById}
        displayDateTip={displayDateTip}
        setDisplayDateTip={setDisplayDateTip}
      />

      <APModal
        open={errorModalOpen}
        onClose={errorModalCloseHandler}
        actions={(
          <button
            onClick={errorModalCloseHandler}
            className="button"
          >
            Ok
          </button>
        )}
      >
        <div>{errorModalMessage}</div>
      </APModal>
      <TimezoneDifferenceModal />
      <TimezoneSetModal />
    </div>
  );
};

export default CalendarIndex;
